<template>
  <div class="article-feature text-body dh-psy-example">
    <DataViz v-if="image" :item="image" />
    <p v-if="item.text" v-html="item.text" />
    <p v-else v-html="item" />
  </div>
</template>

<script>
import DataViz from '../../Media/Graphs/index.vue'

export default {
  props: ['item'], //{ item: { type: String } },
  computed: {
    image() {
      if (typeof this.item === 'string') {
        return
      }

      return {
        value: {
          id: this.item.image,
          'no-margin': true,
          size: 'small'
        }
      }
    }
  },
  components: {
    DataViz
  }
}
</script>

<style scoped>
  div.article-feature.text-body.dh-psy-example {
    margin-bottom: 50px;
    padding: 1em 0 1em;
    color: inherit;
    margin: 0 auto 1em;
    width: calc(100% - 36px);
  }

  .article-feature.dh-psy-example > * {
    padding: 0;
    float: none;
  }

  .article-feature.dh-psy-example > p {
    padding: 1em 2.5em;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  p {
    font-size: 0.8em;
    line-height: 1.6;
    font-family: menlo, inconsolata, consolas, 'fira mono', 'noto mono', 'droid sans mono',
      'dejavu sans mono', 'liberation mono', 'ubuntu mono', monaco, 'courier new', monospace;
  }
</style>
